import { useEffect, useState } from "react";
import API_BASE_URL from "../config";

import {
  FiMail,
  FiPhone,
  FiSearch,
  FiInfo,
  FiDollarSign,
  FiStar,
  FiBookOpen,
  FiLayers,
  FiHelpCircle,
  FiFileText,
  FiShield,
  FiFile
} from "react-icons/fi";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
  FaWhatsapp
} from "react-icons/fa";

import "../styles/Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();
  const [settings, setSettings] = useState({});

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/site-settings`);
        const data = await res.json();
        setSettings(data || {});
      } catch (error) {
        console.error("Footer settings fetch error:", error);
      }
    };

    fetchSettings();
  }, []);

  const whatsappNumber = settings.contactAlternatePhone
    ? settings.contactAlternatePhone.replace(/\s+/g, "")
    : null;

  // 🔥 Social media (including WhatsApp)
  const socialLinks = [
    { key: "facebook", icon: <FaFacebookF />, url: settings.facebookUrl },
    { key: "instagram", icon: <FaInstagram />, url: settings.instagramUrl },
    { key: "linkedin", icon: <FaLinkedinIn />, url: settings.linkedinUrl },
    { key: "twitter", icon: <FaTwitter />, url: settings.twitterUrl },
    { key: "youtube", icon: <FaYoutube />, url: settings.youtubeUrl },
    {
      key: "whatsapp",
      icon: <FaWhatsapp />,
      url: whatsappNumber ? `https://wa.me/${whatsappNumber}` : null
    }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* BRAND */}
        <div className="footer-brand">
          <h3 className="logo">
            {(settings.brandName || "JUSTIVON").toUpperCase()}
          </h3>
          <p>
            Connecting you with trusted legal professionals across the UK.
            Fast, secure and reliable.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-column">
          <h4><FiStar className="icon" /> Quick Links</h4>
          <ul>
            <li><FiSearch /><a href="/search">Browse Solicitors</a></li>
            <li><FiInfo /><a href="/about">About Us</a></li>
            <li><FiPhone /><a href="/contact">Contact Us</a></li>
            <li><FiShield /><a href="/register-solicitor">Join as a Solicitor</a></li>
          </ul>
        </div>

        {/* LEGAL RESOURCES */}
        <div className="footer-column">
          <h4><FiBookOpen className="icon" /> Legal Resources</h4>
          <ul>
            <li><FiFileText /><a href="/legal-insights">Legal Insights</a></li>
            <li><FiLayers /><a href="/practice-areas">Practice Areas</a></li>
            <li><FiBookOpen /><a href="/case-guides">Case Process Guides</a></li>
            <li><FiHelpCircle /><a href="/faq">FAQ</a></li>
          </ul>
        </div>

        {/* CONTACT + SOCIAL */}
        <div className="footer-column">
          <h4><FiPhone className="icon" /> Contact</h4>

          <ul className="contact-list">
            {settings.contactEmail && (
              <li>
                <FiMail />
                <a href={`mailto:${settings.contactEmail}`}>
                  {settings.contactEmail}
                </a>
              </li>
            )}

            {settings.contactPhone && (
              <li>
                <FiPhone />
                <a href={`tel:${settings.contactPhone}`}>
                  {settings.contactPhone}
                </a>
              </li>
            )}
          </ul>

          {/* SOCIAL ICONS (WhatsApp included) */}
          <div className="footer-social-icons footer-social-contact">
            {socialLinks.map(
              item =>
                item.url && (
                  <a
                    key={item.key}
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-social-icon"
                  >
                    {item.icon}
                  </a>
                )
            )}
          </div>
        </div>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <span>
          © {year} {settings.brandName || "Solicitor Finder Ltd."}. All rights reserved.
        </span>

        <div className="footer-bottom-links">
          <a href="/privacy"><FiShield /> Privacy Policy</a>
          <a href="/terms"><FiFile /> Terms of Service</a>
          <a href="/cookies"><FiFileText /> Cookie Policy</a>
        </div>
      </div>
    </footer>
  );
}
